import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import PollIcon from "@/components/PollIcon";

const navItems = [
    { to: "/", label: "Hjem", testId: "nav-home" },
    { to: "/partier", label: "Partier", testId: "nav-parties" },
    { to: "/politikere", label: "Politikere", testId: "nav-politicians" },
    { to: "/quiz", label: "Quiz", testId: "nav-quiz" },
    { to: "/sammenlign", label: "Sammenlign", testId: "nav-compare" },
    { to: "/lofter", label: "Løfter", testId: "nav-promises" },
    { to: "/afstemninger", label: "Afstemninger", testId: "nav-polls" },
    { to: "/statistik", label: "Statistik", testId: "nav-stats" },
    { to: "/artikler", label: "Artikler", testId: "nav-articles" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="sticky top-0 z-40 bg-royal-deep text-white border-b border-white/10"
            data-testid="main-navbar"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    <Link
                        to="/"
                        className="flex items-center gap-2.5 group"
                        data-testid="logo-link"
                    >
                        <div className="w-9 h-9 bg-white flex items-center justify-center rounded-sm rotate-[-3deg] group-hover:rotate-0 transition-transform">
                            <PollIcon size={22} color="#BB1B2D" />
                        </div>
                        <div className="leading-tight">
                            <div className="font-serif-dm text-xl tracking-tight">
                                Løftebarometeret
                            </div>
                            <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">
                                Dansk politisk tillid
                            </div>
                        </div>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-0.5" data-testid="desktop-nav">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.to === "/"}
                                data-testid={item.testId}
                                className={({ isActive }) =>
                                    `px-3 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap ${
                                        isActive
                                            ? "bg-white text-royal"
                                            : "text-white/85 hover:text-white hover:bg-white/10"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>

                    <button
                        className="lg:hidden p-2 rounded-md hover:bg-white/10"
                        onClick={() => setOpen(!open)}
                        data-testid="mobile-nav-toggle"
                        aria-label="Menu"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>

                {open && (
                    <div
                        className="lg:hidden py-3 flex flex-col gap-1 border-t border-white/10"
                        data-testid="mobile-nav"
                    >
                        {navItems.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.to === "/"}
                                onClick={() => setOpen(false)}
                                data-testid={`${item.testId}-mobile`}
                                className={({ isActive }) =>
                                    `px-4 py-2.5 rounded-md text-sm font-medium ${
                                        isActive
                                            ? "bg-white text-royal"
                                            : "text-white/85 hover:bg-white/10"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </div>
                )}
            </div>
        </header>
    );
}
